module.exports = __webpack_public_path__ + "static/media/video-08-ru.cff2b666.webm";